/********************************************
* Media text banner
********************************************/
function fnMediaTextBanners( i, oSection ) {

	var oSection 				= $( oSection ),
		oArticle				= $( 'article', oSection );

	/**
	* Hover buttons
	*/
	oArticle.find( 'a.button' ).hover( function() {
		$( this ).closest( oArticle ).toggleClass( 'hover' );
	});

}


// END OF DOCUMENT
